/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-10-17 10:24:05
 * @LastEditors: caiqin.xie
 * @message: 分页组件
 */
import React from "react";
import { Pagination } from '@arco-design/web-react';
import styles from "./index.module.scss";
import classNames from "classnames";


interface IProps {
  words: Record<string, string>;
  pageNum: number; // 当前页
  total: number; // 总条数
  pages: number; // 总页数
  device: string;
  pageSize?: number; // 每页条数
  pageChange: (pageNum: number) => void; // 页码改变
}

const CustomPagination = (props:IProps) => {
  const {words, pageNum, total, pages, pageSize, device, pageChange} = props

  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)

  // 页码改变事件
  const pageChangeHandler = (pageNum:number) => {
    pageChange(pageNum)
  }

  return (
    <div className={styles['pagination-wrap']}>
      <Pagination
        className={styles['pagination-pc']}
        current={pageNum}
        onChange={(pageNum:number) => pageChangeHandler(pageNum)}
        pageItemStyle={{height: '20px', lineHeight: '20px', padding: '0 16px', borderRadius: '20px'}}
        activePageItemStyle={{backgroundColor: '#3f00f2', color: '#fff'}}
        total={total}
        pageSize={pageSize ?? 10}
        hideOnSinglePage={true} />

      {(pages > 1 && pageNum < pages) && (
        <button
          className={classNames(styles['load-more-purple'], styles['pagination-m'])}
          onClick={() => pageChangeHandler(pageNum + 1)}>
          {words?.common_load_more}
        </button>
      )}
    </div>
  )
}
export default CustomPagination